import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/wild-things-next/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/wild-things-next/node_modules/next/dist/client/image-component.js");
